import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Button = styled.button`
  border: none;
  background: #ce1720;
  color: white;
  font-weight: bold;
  padding: 20px 70px;
  border-radius: 10px;
`;

function Btn({ href, title, style, type, onClick, ...props }) {
  if (href) {
    return (
      <Link to={href}>
        <Button type={type} onClick={onClick} style={style} {...props}>
          {title}
        </Button>
      </Link>
    );
  }
  return (
    <Button type={type} onClick={onClick} style={style} {...props}>
      {title}
    </Button>
  );
}

export default Btn;
